export const Path = {
  HOME: '/home',
  DASHBOARD: '/home',
  TEAM: '/home/teams',
  TASK: '/home/tasks',
  ROUTINE: '/home/routine',
  DATA: '/home/data',
  PAYWALL: '/subscribe',
  STRIPE_CHECKOUT: {
    SUCCESS: '/stripe-checkout/success',
  },
  SETTINGS: {
    ROOT: '/settings',
    CALENDLY: '/settings/calendly/configure',
  },
  CALENDLY: {
    SCHEDULE: '/calendly/schedule/:calendlyIntegId',
  },

  ONBOARDING: {
    // Deprecated below
    CONNECT_DEVICES: '/onboarding/connect-devices',
    ENERGY_PREFERENCE: '/onboarding/energy-preference',
    CONNECT_TODO: '/onboarding/connect-todo',
    AI_SCHEDULER_PRACTICE: '/onboarding/ai-scheduelr-practice',
    INITIAL_SYNC: '/onboarding/initial-sync',
  },

  CALLBACK: {
    TERRA_CALLBACK: '/callback/terra',
    TODOIST_CALLBACK: '/callback/todoist',
    TRELLO_CALLBACK: '/callback/trello',
    TICKTICK_CALLBACK: '/callback/ticktick',
    CLICKUP_CALLBACK: '/callback/clickup',
    NOTION_CALLBACK: '/callback/notion',
    GOOGLE_TASKS_CALLBACK: '/callback/google-tasks',
    GOOGLE_CALLBACK: '/callback/google',
    GOOGLE_AUTH_CALLBACK: '/callback/google-auth',
    OUTLOOK_CALLBACK: '/callback/outlook',
    CALENDLY_CALLBACK: '/callback/calendly',
    GITHUB_CALLBACK: '/callback/github',
    APPLE_AUTH_CALLBACK: '/callback/apple-auth',
  },
};

export const ONBOARDING_PATH = {
  WELCOME: '/onboarding/welcome',
  ENERGY_SITUATION: '/onboarding/energy-situation',
  TESTIMONIAL_OPTIMIZE: '/onboarding/testimonial-optimize',
  GET_STARTED: '/onboarding/get-started',
  NAME_ENTRY: '/onboarding/name-entry',
  PERSONA_SURVEY: '/onboarding/persona-survey',
  MARKETING_SURVEY: '/onboarding/marketing-survey',
  MANUAL_SLEEP_INPUT: '/onboarding/manual-sleep-input',
  ENERGY_PREDICTION_RESULT: '/onboarding/energy-prediction-result',
  POWER_UP_PLAN: '/onboarding/power-up-plan',
  AI_PLAN_PREVIEW: '/onboarding/ai-plan-preview',
  // Kept for redirect safety
  WHAT_SHOULD_I_PLAN: '/onboarding/what-should-i-plan',
  QUICK_PREF: '/onboarding/quick-pref',
  WORK_PREF: '/onboarding/work-pref',
  CONNECT_WORLD: '/onboarding/connect-world',
  ADD_TASK: '/onboarding/add-task',
  ADD_ROUTINE: '/onboarding/add-routine',
  // Deprecated — kept for redirect safety
  ASK_AI_ANYTHING: '/onboarding/ask-ai-anything',
  PEAK_ENERGY_QUESTION: '/onboarding/peak-energy-question',
  SUGGEST_SLEEP: '/onboarding/suggest-sleep',
  PLAN_ENTIRE_DAY: '/onboarding/plan-entire-day',
  SLEEP_DATA_REQUEST: '/onboarding/sleep-data-request',
  CALENDAR_SYNC: '/onboarding/calendar-sync',
  CONNECT_TODO: '/onboarding/connect-todo',
  TIMEBOX_TASK: '/onboarding/timebox-task',
  ADJUST_DAY: '/onboarding/adjust-day',
};
